import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const STREAK_KEY = ["streak", "me"];

export const streakApi = {
  getMine: () => api.get("/streak/me").then((r) => r.data),
};

export function useStreak() {
  return useQuery({
    queryKey: STREAK_KEY,
    queryFn: streakApi.getMine,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
